var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTeamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-width:3.29px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-3{fill:#03244c;}.cls-2{stroke:#fffdfd;stroke-linecap:round;stroke-width:26.29px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1000,
    height: 1000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 343.48,
    y1: 677.43,
    x2: 188.74,
    y2: 875.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 371.62,
    y1: 720.51,
    x2: 271.87,
    y2: 848.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.79,
    y1: 659.7,
    x2: 202.04,
    y2: 787.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m632.37,618.75l9.25-11.84-.91-14.28c-.07-1.05-.58-2.01-1.42-2.64l-52.44-40.81,33.54-42.93-.15-.12,30.23-39.72.82-1.94,21.95-41.2.82-1.94,33.61-59.47.43-1.03.11.08,16.29-33.77,53.23-104.16.09-.15.23-.37.17.13-.03-.24v-.11s.02-.04.02-.04l-.03-.02-.06-.82-3.53-40.29-.07-.06-2.81-7.23-19.57-15.29-2.78-2.17-19.57-15.29-7.7-.97-.07-.06-39.95,6.32-.81.14-.03-.02-.03.03-.1.02-.24.03.17.13-.3.31-.13.12-88.19,76.85-28.82,23.98.11.08-.89.67-49.57,47-1.68,1.27-34.67,31.27-1.68,1.27-31.22,38.94-.15-.12-33.54,42.93-52.29-41.01c-.82-.65-1.88-.92-2.91-.73l-14.07,2.57-9.25,11.84-.1-.08-1.4,1.8-10.83,13.87.1.08-18.24,23.34c-.55.71-.85,1.59-.83,2.48l.38,18.05c.02.96.47,1.87,1.23,2.46l9.89,7.73c.8.62,1.94.48,2.56-.31l10.04-12.85,43,33.6-3.68,8.11-.54,1.16-11,24.25-.53,1.15-8.91,44.97-6.41,7.36-22.79,25.8-2.96,2.61c-2.49,3.19-1.97,7.75,1.16,10.19l57.9,45.23.14.11,57.9,45.23c3.13,2.45,7.68,1.85,10.17-1.34l1.81-3.5,19.52-28.36,5.59-8,41.48-19.53.99-.79,20.86-16.54,1-.8,6.98-5.53,43,33.6-10.04,12.85c-.62.8-.48,1.94.31,2.56l9.89,7.73c.76.59,1.75.81,2.68.6l17.61-4c.88-.2,1.66-.69,2.21-1.4l18.24-23.34.1.08,10.83-13.87,1.4-1.8-.1-.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTeamLogo);
export default __webpack_public_path__ + "static/media/DefaultTeamLogo.165a47ab4d2749641b5eca1bb211a59d.svg";
export { ForwardRef as ReactComponent };